import React from 'react';
import { renderComponent } from 'utils/commonUtils';
import SystemConfigurationForm from './components/SystemConfigurationForm';

const SystemConfiguration = () => {
  return renderComponent(<SystemConfigurationForm />);
};

export default SystemConfiguration;
